const Spin = require('helper/spin');

window.ZCY = {};
ZCY.utils = (function () {
  let _modalId = 0;
  let _ModalTemplate = '';

  function _modal () {
    let param = arguments[0];
    let type = param.type || 'normal';
    // 获取模态框外层基础模板
    if (!_ModalTemplate) {
      _ModalTemplate = Handlebars.templates['templates/modal'];
    }
    let btn = [];
    // 设置默认按钮文字
    if (param.button) {
      btn = param.button;
    }
    let tempData = {
      title: param.title || '提示',
      btn1: (btn)[0] || '取消',
      btn2: (btn)[1] || '确定',
      cls: param.cls || '',
      type,
      content: param.content || ['确认此操作吗？'],
      id: ++_modalId
    };
    // 获取模态框dom节点
    let $modalDom = $(_ModalTemplate(tempData));
    // 获取模态框body 自定义内容
    let html;
    if (param.templateUrl) {
      let data = param.data || {};
      let templates = Handlebars.templates[param.templateUrl];
      html = templates(data);
    }
    if (param.html) {
      html = param.html;
    }
    // 将自定义 body内容嵌入到模态框中
    html && $modalDom.find('.modal-body').html(html);
    // 当模态框不是normal时 内容填入
    if (!html && param.content.length > 0 && type != 'normal') {
      $modalDom.find('.modal-body .info-title').html(param.content[0] || '');
      type == 'second' ?
        $modalDom.find('.modal-body .second-content').html(param.content[1] || '') :
        $modalDom.find('.modal-body .info-content').html(param.content[1] || '');
    }
    const $container = param.container ? param.container : $('body');
    $('#modal-id-' + tempData.id).length == 0 && $container.append($modalDom[0].outerHTML);

    let $modal = $('#modal-id-' + tempData.id);
    $modal.modal('show');

    // 绑定按钮事件
    $modal.find('.modal-footer button').unbind('click.ZCY').bind('click.ZCY', function () {
      if ($(this).hasClass('btn-cancel')) {
        $.isFunction(param.cancel) ? param.cancel($modal) : $modal.modal('hide');
      } else {
        $.isFunction(param.confirm) ? param.confirm($modal) : $modal.modal('hide');
      }
    });
    // 加载弹框show后的事件
    $.isFunction(param.afterRander) && param.afterRander($modal, '#modal-id-' + tempData.id);

    // 二次弹框 CheckBox 选择时 按钮disabled 控制
    if (type == 'second') {
      $('#modal-id-' + tempData.id).find('.second-checkbox').on('change.zcy', function () {
        if ($(this).is(':checked')) {
          $('#modal-id-' + tempData.id).find('.btn-success').removeAttr('disabled');
        } else {
          $('#modal-id-' + tempData.id).find('.btn-success').attr('disabled', true);
        }
      });
    }

    return {
      dom: $('#modal-id-' + tempData.id),
      modal: $modal
    };
  }

  function _getData () {
    let $tar = $(arguments[0]).find('[name]');
    let result = {};
    let config = arguments[1] || {};
    $.each($tar, function (i, v) {
      let $dom = $(this);
      let _pop = $dom.attr('name');
      if ($dom.hasClass(config.ignore)) {
        return true;
      }
      let value = '';

      if ($dom.is('input')) {
        if ($dom.hasClass(config.money)) {

        } else if ($dom.hasClass(config['date-sec'])) {

        } else {
          result[_pop] = $dom.val();
        }
      } else if ($dom.is('select')) {
        result[_pop] = $dom.val();
        // $dom.val() && (result[_pop + 'text'] = $dom.find('option:selected').text());
      }
    });
    return result;
  }

  function _emptyData () {
    let $tar = $(arguments[0]).find('[name]');
    $.each($tar, function () {
      let $dom = $(this);
      if ($dom.is('input')) {
        $dom.val('');
      } else if ($dom.is('select')) {
        if ($dom.parent().parent().hasClass('selectric-wrapper')) {
          let $selectric = $dom.parent().parent();
          $selectric.find('.selectric .label').text('请选择');
          $selectric.find('.selectric-items li').removeClass('selected');
        }
        $dom.prop('selectedIndex', 0);
      }
    });
  }

  $.fn.getData = function () {
    return _getData($(this), arguments[0]);
  };

  $.fn.emptyData = function () {
    return _emptyData($(this));
  };

  $.fn.spin = function () {
    return new Spin({ top: '45%' }).spin(this[0]);
  };

  return {
    modal () {
      return _modal.apply(this, arguments);
    }
  };
})();
